import Image from 'app/Components/Shared/Image/image';
import React, { useRef, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import { connect } from "react-redux";
import {
  getDeliveryNoProducts,
  deliveryChangeHandler,
  changeHandler,
  startLoading,
  clearTimeSlots,
  deliveryValidateHandler,
  expandElement,
  enableEdit,
  populateForm,
  updateOrCancel,
  showApprovePopup,
  clearValid,
  setSavedSuccessfullyVisible,
  setIsShowFail,
} from "./UpdateDeliverySlotSlice";
import ReactSelect from "../../../Shared/ReactSelect/ReactSelect";
import TextInput from "../../../Shared/TextInput/TextInput";
import AddressFrm from "../../../Shared/AddressFrm/AddressFrm";
import {
  setHomeNum,
  clearAddress,
} from "../../../Shared/AddressFrm/addressFrmSlice";
import PopUp from "../../../Shared/Popup/PopUp";
import BtnSubmit from "../../../Shared/Buttons/BtnSubmit";
import {
  showAppLoader,
  hideAppLoader,
} from "../../../Shared/Loader/LoaderSlice";
import { myDeliveries } from "../UpdateDeliverySlotHolder/UpdateDeliverySlotHolderSlice";
import gaParams from "../../../../utilities/analytics/constants";
import { gaEvent } from "../../../../utilities/analytics/tracking";
import arrowIcon from './images/icons-arrow.svg';

const updateDeliverySlot = (props) => {
  const focusBtn = useRef(null);
  const { saveAs } = require("file-saver");
  const ics = require("ics");
  let sameNoteOrders = "";

  const checksameNoteOrders = () => {
    if (props.sameNoteOrders != false) {
      if (props.sameNoteOrders.some((x) => x.idx == props.idx)) {
        return (sameNoteOrders = "true");
      }
    } else return "false";
  };

  const addressData = {
    city: props.addressForm.form.cityName,
    street: props.addressForm.form.streetName,
    homeNum: props.addressForm.form.home,
    slotTimeNoteOrder: checksameNoteOrders(),
    slotTimeDate: props.data.deliverySlots[0].date
      .replace("/", "-")
      .replace("/", "-"),
    slotTimeFrom: props.data.deliverySlots[0].start,
  };

  const objectForUpdate = {
    Ban: props.data.customer.ban,
    DispatchOrder: props.data.dispatchOrderNumber,
    NoteOrder: props.data.noteOrder,
    deliveryRequestAction: "SHIPMENT_CHANGE",
    NewCity: props.addressForm.form.cityName,
    NewStreet: props.addressForm.form.streetName,
    NewHome: props.addressForm.form.home,
    NewApartment: props.addressForm.form.apartment,
    NewDeliveryDate: props.form.lfdat,
    NewRoundFrom: props.form.waitFrom,
    NewRoundTo: props.form.waitTo,
    UserName: props.form.userName,
    PhoneForDelivery: props.form.phone,
    PhoneForDelivery2: props.form.phone2,
    PickLocation: props.form.pickLocation,
    Round: props.form.round,
    Comments: props.form.comments,
  };

  useEffect(() => {
    if (props.form.isLoading == false) {
      props.hideAppLoader();
      if (props.elementIndex == props.idx) {
        focusBtn.current.focus();
      }
    }
  }, [props.form.isLoading]);

  useEffect(() => {
    if (props.isApprovePopupShow == false) {
      gaEvent(
        gaParams.DELIVERY_CANCEL_REJECT.category,
        gaParams.DELIVERY_CANCEL_REJECT.eventType,
        gaParams.DELIVERY_CANCEL_REJECT.eventParams,
      );
    }
  }, [props.isApprovePopupShow]);

  useEffect(() => {
    if (
      props.addressForm.form.streetName != "" &&
      props.addressForm.form.cityName != ""
    ) {
      if (props.elementIndex == props.idx) {
        const street = props.data.street;
        const city = props.data.city;
        props.showAppLoader();
        props.startLoading(true);
        props.getDeliveryNoProducts(addressData);

        if (
          props.addressForm.form.streetName != street ||
          props.addressForm.form.cityName != city
        ) {
          props.clearTimeSlots();
        }
      }
    }
  }, [props.addressForm.form.streetName, props.addressForm.form.cityName]);

  useEffect(() => {
    if (
      props.addressForm.form.street == " " ||
      props.addressForm.form.city == " "
    ) {
      props.hideAppLoader();
    }
  }, [props.addressForm.form.street, props.addressForm.form.city]);

  useEffect(() => {
    if (props.slotsCount == 1) {
      props.expandElement(0);
    }
  }, []);

  useEffect(() => {
    if (props.form.valid) {
      if (props.elementIndex == props.idx) {
        props.updateOrCancel(objectForUpdate);
        props.showAppLoader();
      }
    }
    if (!props.form.valid) {
      props.hideAppLoader();
    }
  }, [props.form.valid]);

  useEffect(() => {
    if (props.isEdit == false) {
      props.clearAddress(props.addressForm);
    }
  }, [props.isEdit]);

  useEffect(() => {
    props.clearValid();
    if (props.updateSuccess != "" || props.updateSuccess == false) {
      props.hideAppLoader();
    }
    if (props.updateSuccess == true && props.elementIndex == props.idx) {
      props.myDeliveries();
      props.enableEdit();
      props.hideAppLoader();
      props.showApprovePopup(false);
      if (props.isSavedSuccessfullyVisible == true) {
        setTimeout(() => props.setSavedSuccessfullyVisible(false), 3000);
      }
    }
  }, [props.updateSuccess]);

  const setCalendar = (props) => {
    gaEvent(
      gaParams.DELIVERY_CALENDAR_ADD.category,
      gaParams.DELIVERY_CALENDAR_ADD.eventType,
      gaParams.DELIVERY_CALENDAR_ADD.eventParams,
    );
    let dateArr = props.data.deliverySlots[0].date.split("/");
    let eventDelivery = {
      start: [
        parseInt(dateArr[2]),
        parseInt(dateArr[1]),
        parseInt(dateArr[0]),
        parseInt(props.data.deliverySlots[0].start),
        0,
      ],
      duration: { hours: 2 },
      title: `שליחות ${window.Config.brand_Name_HE}`,
      description: setTitleAndLogo(props.data).title,
      location: "",
      status: "CONFIRMED",
      busyStatus: "BUSY",
    };

    ics.createEvent(eventDelivery, (error, value) => {
      if (error) {
        return;
      }
      var file = new File([value], "event.ics", {
        type: "text/calendar;charset=utf8",
      });
      saveAs(file);
    });
  };

  const checkIfUpdateAllowed = (props) => {
    if (
      getCurrentDate() != props.data.deliverySlots[0].date &&
      props.data.actions.updateAllowed
    ) {
      return true;
    } else {
      return false;
    }
  };

  const checkIfCancelAllowed = (props) => {
    if (
      getCurrentDate() != props.data.deliverySlots[0].date &&
      props.data.actions.cancelAllowed
    ) {
      return true;
    } else {
      return false;
    }
  };

  const getCurrentDate = () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();
    today = dd + "/" + mm + "/" + yyyy;
    return today;
  };

  const setShipmentType = (shipmentType) => {
    switch (shipmentType) {
      case "איסוף":
        return "החזרה של ציוד ";
        break;
      case "מסירה":
        return "קבלה של ציוד ";
        break;
      case "איסוף ומסירה":
        return "החזרה וקבלה של ציוד ";
        break;
      default:
        return "";
    }
  };

  const setTitleAndLogo = (props) => {
    switch (props.equipmentType) {
      case "QUATTRO":
        return {
          title: setShipmentType(props.shipmentType) + "קוואטרו",
          logo: require("./images/icons-truck-delivery.svg"),
        };
        break;
      case "QUATTRO,CELLULAR":
        return {
          title:
            setShipmentType(props.shipmentType) + "אינטרנט וציוד סלולר/ סים",
          logo: require("./images/icons-truck-delivery.svg"),
        };
        break;
      case "TRIPLE":
        return {
          title: setShipmentType(props.shipmentType) + "טריפל",
          logo: require("./images/icons-truck-delivery.svg"),
        };
        break;
      case "BUNDLE":
        return {
          title: setShipmentType(props.shipmentType) + "אינטרנט",
          logo: require("./images/icons-fast-wifi.svg"),
        };
        break;
      case "CELLULAR":
        return {
          title: setShipmentType(props.shipmentType) + "סלולר",
          logo: require("./images/icons-sim.svg"),
        };
        break;
      case "TV":
        return {
          title: setShipmentType(props.shipmentType) + `${window.Config.brand_Name_HE} TV`,
          logo: require("./images/icons-4-k.svg"),
        };
        break;
      case "OTHER":
        return {
          title: "קבלת שליחות / החזרת ציוד",
          logo: require("./images/icons-truck-delivery.svg"),
        };
        break;
      case "":
        return {
          title: setShipmentType(props.shipmentType) + " כמחווה שירותית",
          logo: require("./images/icons-truck-delivery.svg"),
        };
        break;
      default:
        return "";
    }
  };

  const updateDelivery = (props) => {
    props.deliveryValidateHandler(props.form);
  };

  const showCancelPopUp = () => {
    gaEvent(
      gaParams.DELIVERY_CANCEL_CLICK.category,
      gaParams.DELIVERY_CANCEL_CLICK.eventType,
      gaParams.DELIVERY_CANCEL_CLICK.eventParams,
    );
    props.showApprovePopup(true);
  };

  const CancelDelivery = () => {
    gaEvent(
      gaParams.DELIVERY_CANCEL_APPROVE.category,
      gaParams.DELIVERY_CANCEL_APPROVE.eventType,
      gaParams.DELIVERY_CANCEL_APPROVE.eventParams,
    );
    props.showAppLoader();
    const objectForCancel = {
      Ban: props.data.customer.ban,
      DispatchOrder: props.data.dispatchOrderNumber,
      NoteOrder: props.data.noteOrder,
      deliveryRequestAction: "SHIPMENT_CANCEL",
      NewCity: props.data.city,
      NewStreet: props.data.street,
      NewHome: props.data.houseNumber,
      NewApartment: "",
      NewDeliveryDate: props.data.deliverySlots[0].date,
      NewRoundFrom: props.data.deliverySlots[0].start,
      NewRoundTo: props.data.deliverySlots[0].end,
      UserName: props.data.customer.name,
      PhoneForDelivery: props.form.phone,
      PhoneForDelivery2: props.form.phone2,
      PickLocation: "",
      Round: "",
    };
    if (checkIfCancelAllowed(props)) {
      props.updateOrCancel(objectForCancel);
    } else {
      props.setIsShowFail(true);
    }
  };

  const enableEditAndSetHomeNum = (props) => {
    props.showAppLoader();
    gaEvent(
      gaParams.DELIVERY_UPDATE_CLICK.category,
      gaParams.DELIVERY_UPDATE_CLICK.eventType,
      gaParams.DELIVERY_UPDATE_CLICK.eventParams,
    );
    props.setHomeNum({
      HomeNum: props.data.houseNumber,
      Apartment: props.data.apartment,
    });
    props.enableEdit(props.data);
  };

  let selectDeliverySlot = (
    <ReactSelect
      preventKeyboard={false}
      required={true}
      error={props.form.errors.deliveryTime}
      getOptionLabel={(option) => option.value}
      getOptionValue={(option) => option.key}
      placeholder={
        props.form.deliveryTime
          ? props.form.deliveryTime
          : props.form.deliveryTimePlaceholder
      }
      isLoading={props.form.isLoading}
      value={props.deliveryTimeSlots.filter(
        (option) => option.key === props.form.deliveryTime,
      )}
      name="deliveryTime"
      options={props.deliveryTimeSlots}
      onChange={(e) =>
        props.deliveryChangeHandler({
          target: {
            name: "deliveryTime",
            value: e.key,
            startDate: e.startDate,
            endDate: e.endDate,
            round: e.round,
            roundName: e.roundName,
            waitFrom: e.waitFrom,
            waitTo: e.waitTo,
            lfdat: e.lfdat,
            weekdayL: e.weekdayL,
            pickLocation: e.pickLocation,
          },
          form: props.form,
        })
      }
    />
  );

  let editAddress = (
    <div>
      <section className="data-container">
        <AddressFrm
          cityDefault={props.populatedCity}
          streetDefault={props.populatedStreet}
        />
      </section>
      <section className="data-container">
        <div className="headline">מתי:</div>
        {selectDeliverySlot}
      </section>
      <section className="data-container">
        <div className="headline">איפה ומתי ניפגש?</div>
        <Row>
          <Col ms={4}>
            <TextInput
              error={props.form.errors.userName}
              placeholder="שם"
              id="userName"
              name="userName"
              maxLength="20"
              type="text"
              autoComplete="off"
              value={props.form.userName}
              onChange={(e) =>
                props.changeHandler({ target: e.target, form: props.form })
              }
              required="required"
            />
          </Col>
        </Row>
        <Row>
          <Col ms={4}>
            <TextInput
              error={props.form.errors.phone}
              placeholder="טלפון לבירורים "
              id="phone"
              name="phone"
              maxLength="10"
              type="number"
              pattern="[0-9]*"
              autoComplete="off"
              value={props.form.phone}
              onChange={(e) =>
                props.changeHandler({ target: e.target, form: props.form })
              }
              required="required"
            />
          </Col>
        </Row>
        {props.data.customer.contacts.contactNo2 != "" ? (
          <Row>
            <Col ms={4}>
              <TextInput
                error={props.form.errors.phone2}
                placeholder="טלפון נוסף "
                id="phone2"
                name="phone2"
                maxLength="10"
                type="number"
                autoComplete="off"
                value={props.form.phone2}
                onChange={(e) =>
                  props.changeHandler({ target: e.target, form: props.form })
                }
              />
            </Col>
          </Row>
        ) : null}
      </section>
      <section className="data-container">
        <div className="headline">הערות לשליח</div>
        <Row>
          <Col ms={4}>
            <TextInput
              error={props.form.errors.comments}
              placeholder="למשל, כניסה מסביב או להשאיר ליד הדלת"
              id="comments"
              name="comments"
              maxLength="50"
              type="text"
              autoComplete="off"
              value={props.form.comments}
              onChange={(e) =>
                props.changeHandler({ target: e.target, form: props.form })
              }
            />
          </Col>
        </Row>
      </section>
      <div className="note">
        <Row>
          <Col xs="1" className="note-star">
            *
          </Col>
          <Col xs="11" className="pr-0">
            חשוב שמי שיפגוש את השליח יהיה מעל גיל 18
          </Col>
        </Row>
        {props.data.equipmentType == "CELLULAR" ? (
          <Row>
            <Col xs="1" className="note-star">
              *
            </Col>
            <Col xs="11" className="pr-0">
              אם אתם מקבלים כרטיס סים חדש, השליח יכול להשאיר אותו בתיבת הדואר,
              גם אם אתם לא בבית
            </Col>
          </Row>
        ) : null}
      </div>
    </div>
  );

  let currentAddress = (
    <div>
      {props.isSavedSuccessfullyVisible ? (
        <div className="saved-container">
          <div className="saved">
            <div className="saved__bg"></div>
            <div className="saved__success">
              <Image src={require("./images/icons-v-ok.svg")} alt="ok" />
              <span>נשמר</span>
            </div>
          </div>
        </div>
      ) : null}
      <section className="data-container">
        {<div className="headline">איפה ומתי ניפגש?</div>}
        <div className="static-text">{props.data.address}</div>
      </section>
      <section className="data-container">
        <div className="headline">מתי:</div>
        <div className="static-text">
          <span className="static-text">
            {props.data.deliverySlots[0].day} &nbsp;
          </span>
          <span className="static-text">
            {props.data.deliverySlots[0].date} &nbsp; &nbsp;{" "}
          </span>
          <span className="static-text">
            {props.data.deliverySlots[0].start} -{" "}
            {props.data.deliverySlots[0].end}
          </span>
        </div>
      </section>
      <section className="data-container">
        <div className="headline">מי יפגוש את השליח?</div>
        <div className="static-text">{props.data.customer.name}</div>
        <div>
          <div className="headline"> טלפון לבירורים:</div>
          <div className="static-text">
            {props.data.customer.contacts.contactNo1}
          </div>
          {props.data.customer.contacts.contactNo2 != "" &&
          props.data.customer.contacts.contactNo2 != "*" ? (
            <div className="static-text">
              {props.data.customer.contacts.contactNo2}
            </div>
          ) : null}
        </div>
      </section>
      <section className="data-container">
        <div className="headline">הערות לשליח</div>
        <div className="static-text">{props.data.comments}</div>
      </section>
      <div className="note">
        <Row>
          <Col xs="1" className="note-star">
            *
          </Col>
          <Col xs="11" className="pr-0">
            חשוב שתהיה מעל גיל 18
          </Col>
        </Row>
        {props.data.shipmentType != "איסוף" ? (
          <Row>
            <Col xs="1" className="note-star">
              *
            </Col>
            <Col xs="11" className="pr-0">
              אם אתם מקבלים כרטיס סים חדש, השליח יכול להשאיר אותו בתיבת הדואר,
              גם כשאתם לא בבית
            </Col>
          </Row>
        ) : null}
      </div>
    </div>
  );

  let cancelEditModeFooter = (
    <Row>
      <Col className="edit-footer">
        <div>
          <button className="btn-enabled" onClick={() => props.enableEdit()}>
            חזור
          </button>
        </div>
        <div>
          <button
            className="btn-delivery"
            onClick={() => updateDelivery(props)}
          >
            שמירה
          </button>
        </div>
      </Col>
    </Row>
  );

  let editModeFooter = (
    <Row>
      <Col className="edit-footer">
        <div>
          <button
            className={
              checkIfUpdateAllowed(props) ? "btn-enabled" : "btn-disabled"
            }
            onClick={() => enableEditAndSetHomeNum(props)}
          >
            עריכה
          </button>
        </div>
        <div xs="6">
          <button
            className={
              props.data.status == "שליחות בוטלה"
                ? "btn-disabled"
                : "btn-enabled"
            }
            onClick={() => setCalendar(props)}
          >
            הוספת תזכורת ליומן
          </button>
        </div>
        <div>
          <button
            onClick={(e) => showCancelPopUp(props, e.target)}
            className="btn-enabled"
          >
            ביטול
          </button>
        </div>
      </Col>
    </Row>
  );

  function closePopUpAndActivateScroll() {
    document.getElementsByTagName("body")[0].classList.remove("modal-open");
    props.showApprovePopup(false);
  }

  return (
    <Container className="delivery-slot">
      <Row>
        <Col className="delivery-slot-container">
          <div className="slot-row">
            <Row onClick={() => props.expandElement(props.idx)}>
              <Col xs="2" md="1" className="slot-icon">
                <Image src={setTitleAndLogo(props.data).logo} alt="לוגו" />
              </Col>
              <Col xs="8" md="6">
                <div className="slot-title">
                  {setTitleAndLogo(props.data).title}
                </div>
                <div className="note">{props.data.status}</div>
              </Col>
              <Col xs="2" md="5">
                {/* <div className={props.elementIndex === props.idx ? 'arrow-shrink' : 'arrow-expand'}>
                  <img src={require('./images/icons-arrow.svg')} alt='חץ'></img>
                </div> */}
                <button
                  ref={focusBtn}
                  type="submit"
                  style={{ backgroundImage: arrowIcon.bg() }}
                  className={
                    props.elementIndex === props.idx
                      ? "arrow-shrink"
                      : "arrow-expand"
                  }
                ></button>
              </Col>
            </Row>
          </div>
          <div>
            <Row>
              {props.elementIndex === props.idx ? null : (
                <Col className="delivery-date">
                  <div>
                    <span>{props.data.deliverySlots[0].day} &nbsp;</span>
                    <span>
                      {props.data.deliverySlots[0].date} &nbsp; &nbsp;
                    </span>
                    <span>
                      {props.data.deliverySlots[0].start} -{" "}
                      {props.data.deliverySlots[0].end}
                    </span>
                  </div>
                </Col>
              )}
            </Row>
          </div>
          {props.elementIndex === props.idx ? (
            <div>
              {props.isEdit ? editAddress : currentAddress}
              {props.isEdit ? cancelEditModeFooter : editModeFooter}
            </div>
          ) : null}
        </Col>
        <div>
          {props.isApprovePopupShow && props.elementIndex == props.idx ? (
            <div className="popup-container">
              <PopUp
                showPopUp={props.isApprovePopupShow}
                onClose={() => closePopUpAndActivateScroll()}
                id="popup-approve"
              >
                <div>
                  <p className="cancel-title">שנבטל את השליחות?</p>
                  <div
                    className="d-flex align-items-center"
                    style={{ justifyContent: "space-evenly" }}
                  >
                    <div
                      className="approve-cancel"
                      onClick={(e) => CancelDelivery(props, e.target)}
                    >
                      <div className="d-flex align-items-center justify-content-center">
                        <span>כן, אפשר לבטל</span>
                        <Image src={require("./images/arrow.svg")}
                          alt="חץ"
                          style={{
                            position: "relative",
                            top: "-2px",
                            right: "2px",
                          }} />
                      </div>
                    </div>
                    <BtnSubmit
                      onclick={() => closePopUpAndActivateScroll()}
                      text="בעצם לא"
                    ></BtnSubmit>
                  </div>
                </div>
              </PopUp>
            </div>
          ) : null}
        </div>
      </Row>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    form: state.updateDeliverySlot.form,
    elementIndex: state.updateDeliverySlot.elementIndex,
    isEdit: state.updateDeliverySlot.isEdit,
    isSubmit: state.updateDeliverySlot.isSubmit,
    isShowFail: state.updateDeliverySlot.isShowFail,
    addressForm: state.addressForm,
    deliveryTimeSlots: state.updateDeliverySlot.deliveryTimeSlots,
    populatedCity: state.updateDeliverySlot.populatedCity,
    populatedStreet: state.updateDeliverySlot.populatedStreet,
    populatedHome: state.updateDeliverySlot.populatedHome,
    mode: state.updateDeliverySlot.mode,
    isApprovePopupShow: state.updateDeliverySlot.isApprovePopupShow,
    updateSuccess: state.updateDeliverySlot.updateSuccess,
    isSavedSuccessfullyVisible:
      state.updateDeliverySlot.isSavedSuccessfullyVisible,
  };
};

const mapDispatchToProps = {
  getDeliveryNoProducts,
  deliveryValidateHandler,
  clearTimeSlots,
  startLoading,
  deliveryChangeHandler,
  changeHandler,
  expandElement,
  enableEdit,
  populateForm,
  updateOrCancel,
  showApprovePopup,
  setHomeNum,
  clearAddress,
  showAppLoader,
  hideAppLoader,
  clearValid,
  myDeliveries,
  setSavedSuccessfullyVisible,
  setIsShowFail,
};

export default connect(mapStateToProps, mapDispatchToProps)(updateDeliverySlot);
